import { GET_COMMENT } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_COMMENT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_COMMENT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_COMMENT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
